import React, { useState } from 'react';
import Select from 'react-select';
import './styles.css';

const Categories = ({
  title,
  children,
  isEditing,
  onFieldChange,
  canEdit,
  categories,
  googleProfileInfo,
  additionalCategories = []
}) => {
  const [localValue, setLocalValue] = useState(children);

  // MinusIcon is used for empty fields
  const isMinusIcon =
    children.props?.className?.includes('fas fa-minus') ||
    (typeof children === 'string' && children === 'fas fa-minus');

  const handleInputChange = (e) => {
    const newValue = e.target.value;

    if (isMinusIcon) {
      setLocalValue(localValue);
    }

    if (isEditing && canEdit && !isMinusIcon) {
      setLocalValue(newValue);
      onFieldChange(newValue);
    }
  };

  return (
    <div className="info-field">
      <div>
        <div>
          <strong>{title}:</strong>
        </div>
      </div>
      <div style={{ marginTop: '14px' }}>
        {isEditing && canEdit && !isMinusIcon ? (
          <>
            <Select
              id="categories"
              options={categories}
              value={categories.find(
                (option) => option.value === googleProfileInfo
              )}
              onChange={async (selectedOption) => {
                console.log('newValue: ', selectedOption);
                setLocalValue(selectedOption);
                onFieldChange(selectedOption);
              }}
              styles={{
                singleValue: (base) => ({
                  ...base,
                  display: 'flex',
                  alignItems: 'center'
                })
              }}
            />
          </>
        ) : (
          <div>
            {isEditing && canEdit && isMinusIcon ? (
              <>
                <Select
                  id="categories"
                  options={categories}
                  value={''}
                  onChange={handleInputChange}
                  styles={{
                    singleValue: (base) => ({
                      ...base,
                      display: 'flex',
                      alignItems: 'center'
                    })
                  }}
                />
              </>
            ) : (
              <>
                <div>
                  {/* Categoría principal */}
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginBottom: '6px',
                      gap: '8px'
                    }}>
                    <span
                      style={{
                        color: '#333',
                        fontSize: '0.875rem'
                      }}>
                      {localValue}
                    </span>
                    <span
                      style={{
                        backgroundColor: '#3766a8',
                        color: '#fff',
                        padding: '2px 6px',
                        borderRadius: '3px',
                        fontSize: '0.65em',
                        fontWeight: '500',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px'
                      }}>
                      PRIMARY
                    </span>
                  </div>

                  {/* Categorías adicionales */}
                  {additionalCategories && additionalCategories.length > 0 && (
                    <div>
                      {additionalCategories.map((category, index) => (
                        <div
                          key={index}
                          style={{
                            marginBottom: '4px',
                            color: '#333',
                            fontSize: '0.875rem'
                          }}>
                          {category.displayName}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Categories;
